<app-header *ngIf="isAppAgentOrTravelAgency" />

<div *ngIf="debugMode" nxLayout="grid" class="nx-margin-bottom-m" style="padding-top: 24px;">
  <nx-error>
    <p class="azt-test" nxCopytext="normal">App kind: {{ debugAppKind || 'unknown' }}</p>
    <p class="azt-test" nxCopytext="normal">Build version: 1</p>
    <p class="azt-test" nxCopytext="normal">This application works in debug mode. Please disable it in production.</p>
    <p class="azt-test" nxCopytext="normal">Version: {{ debugVersion }} ({{debugBuild}})</p>
    <br />
    <button nxPlainButton type="button" class="nx-margin-bottom-m" (click)="toggleDebugModeVisibility()">Show
      debug</button>
    <br />
    <button nxPlainButton type="button" (click)="turnOffDebugMode()">Turn off debug mode</button>
    <br />
    <button nxPlainButton type="button" (click)="turnOnTrackingDebugMode()">Turn on tracking debug mode</button>
    <button nxPlainButton type="button" (click)="turnOffTrackingDebugMode()">Turn off tracking debug mode</button>
  </nx-error>
  <div>
    <div *ngIf="debugModeVisible && debugMode" nxRow class="nx-margin-top-2m" nxRow>
      <div nxCol="12">
        <hr />
      </div>
      <div nxCol="12">
        <nx-formfield label="Change language">
          <nx-dropdown [value]="currentLanguage" (selectionChange)="handleChangeLanguage($event)">
            <nx-dropdown-item *ngFor="let language of languageList" [value]="language.code">{{ language.name
              }}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
      <div nxCol="12">
        <button nxButton class="nx-margin-right-s nx-margin-bottom-s" (click)="handleDevClearStore()">Clear
          store</button><br />
      </div>
    </div>
  </div>
</div>

<app-loader *ngIf="configIsLoading$ | async" view="fixed"></app-loader>

<main class="container app-main">
  <app-progress-stepper></app-progress-stepper>

  <app-navigation-error />

  <nx-message *ngIf="importedToForm$ | async" context="success"
    class="insureds-imported insureds-imported--position-fixed">
    {{ 'modals.insured-import.import-success' | translate }}
    <button nxPlainButton class="insureds-imported--close" type="button" (click)="closeInsuredImported()">
      <nx-icon name="close" size="auto"></nx-icon>
    </button>
  </nx-message>

  <app-load-policy-messages></app-load-policy-messages>

  <router-outlet></router-outlet>

  <app-navigation></app-navigation>

  <app-affiliate-links-info *ngIf="isAppAgent && procesStep() === 0" />

</main>

<div *ngIf="(discountCodeIsValid$ | async) && (currentStep$ | async) === 2" class="disclaimers">
  <div class="container">
    <p nxCopytext="small" [innerHTML]="'offer.discount.disclaimer' | translate | markdown"></p>
  </div>
</div>